import { JSX } from 'react';
// @ts-ignore - no type declarations for 'react-html-parser'
import ReactHtmlParser from 'react-html-parser';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography
} from '@mui/material';

interface FaqItem {
  question: string;
  answer: string | string[];
}

interface FaqCategoryTitleProps {
  faq: FaqItem;
  onToggle: () => void;
  active?: boolean;
}

const FaqCategoryTitle = ({
  faq,
  onToggle,
  active
}: FaqCategoryTitleProps): JSX.Element => {
  const { question, answer } = faq;

  return (
    <>
      <Accordion
        expanded={!!active}
        onChange={onToggle}
        sx={{
          mb: 'var(--spacing-lg)',
          border: '1px solid #DBDDDC',
          '&:before': { display: 'none' },
          '&.Mui-expanded': {
            mb: 'var(--spacing-lg)'
          }
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography
            sx={{
              font: 'var(--sprout-font-body1-bold)'
            }}
          >
            {ReactHtmlParser(question)}
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          {!Array.isArray(answer) ? (
            <Typography
              variant="body1"
              sx={{
                paddingTop: 'var(--spacing-xl)',
                paddingRight: 'var(--spacing-2xl)'
              }}
            >
              {ReactHtmlParser(answer)}
            </Typography>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingTop: 'var(--spacing-xl)',
                paddingRight: 'var(--spacing-2xl)',
                gap: '24px'
              }}
            >
              {answer.map((ans, index) => (
                <Typography
                  variant="body1"
                  key={`${ans.substring(0, 50)}-${index}`}
                >
                  {ReactHtmlParser(ans)}
                </Typography>
              ))}
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default FaqCategoryTitle;